export class ContactDetailPublishInfoRawDto {
  contactDetailId: number;
  sequence: number;
  title: string;
  information: string;
  published: boolean;
}
